<template>
    <Transition
        enter-active-class="transition duration-200 ease-out"
        enter-from-class="opacity-0 -translate-y-2"
        enter-to-class="opacity-100 translate-y-0"
        leave-active-class="transition duration-150 ease-in"
        leave-from-class="opacity-100 translate-y-0"
        leave-to-class="opacity-0 -translate-y-2">
        <div v-if="open" ref="panel" class="flex flex-col gap-2 p-2.5 border-t">
            <p class="body-small">{{ prompt }}</p>
            <div class="flex flex-col sm:flex-row gap-2 sm:justify-center">
                <BaseButton theme="primary" :disabled="isConfirming" class="w-full sm:w-auto sm:min-w-35 sm:order-2" @click="open = false">{{ cancelLabel }}</BaseButton>
                <BaseButton
                    theme="tertiary"
                    :disabled="isConfirming"
                    class="w-full sm:w-auto sm:min-w-35 sm:order-1 flex items-center justify-center gap-2"
                    @click="$emit('confirm')">
                    <LoadingSpinner v-if="isConfirming" class="h-4 w-4" />
                    {{ confirmLabel }}
                </BaseButton>
            </div>
        </div>
    </Transition>
</template>

<script setup lang="ts">
import { breakpointsTailwind, useBreakpoints } from "@vueuse/core";
import BaseButton from "~vue/components/BaseButton.vue";
import LoadingSpinner from "~vue/icons/LoadingSpinner.vue";
import { nextTick, ref, watch } from "vue";

const {
    prompt,
    confirmLabel,
    cancelLabel = "Cancel",
    isConfirming = false,
} = defineProps<{
    prompt: string;
    confirmLabel: string;
    cancelLabel?: string;
    isConfirming?: boolean;
}>();

defineEmits<{ confirm: [] }>();

const open = defineModel<boolean>("open", { default: false });
const panel = ref<HTMLElement | null>(null);
const isMobile = useBreakpoints(breakpointsTailwind).smaller("md");

watch(open, async (val) => {
    if (val) {
        await nextTick();
        panel.value?.scrollIntoView({ behavior: "smooth", block: isMobile.value ? "nearest" : "center" });
    }
});
</script>
